//
//
//
//

export default {
  props: {
    expanded: { type: Boolean, required: true }
  }
}
